import React, { Component } from "react";
import Reported from "../../../components/Reported/Reported";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ReportedForm
Description : Componente que invoca al componente Reported, para la creación y consulta de reportados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Reported
================================================================================ */
class ReportedForm extends Component{
    render(){
        return(
            <Reported/>  
        )   
    }
}

export default ReportedForm;